import { TestIdDomain } from 'constants/testIds';

const DocumentTestIdsScope = {
  AI_LAYERS: 'ai-layers',
  BOUNDING_BOX: 'bounding-box',
  CONTROL_PANEL: 'control-panel',
  DOCUMENTS_UPLOAD: 'documents-upload',
  DOCUMENT_PREVIEW: 'document-preview',
  EXTRACTION_FIELD: 'extraction-field',
  HISTORY_TABLE_ROW: 'history-table-row',
  REJECT_DOCUMENT: 'reject-document',
  THUMBNAIL: 'thumbnail',
  TREE_HEADER: 'tree-header',
};

export const DocumentTestIds = {
  // ControlPanel
  DOCUMENT_PREVIEW_CONTROL_PANEL: `${DocumentTestIdsScope.DOCUMENT_PREVIEW}.control-panel`,
  SCALE_DROPDOWN_SELECT: 'scale.dropdown-select',
  SELECT_PAGE_INPUT: 'select-page.input',
  CONTROL_PANEL_LAYERS_BUTTON: `${DocumentTestIdsScope.CONTROL_PANEL}.layers-button`,

  // AiLayersPopover
  getAiLayerCheckboxId: value => `${DocumentTestIdsScope.AI_LAYERS}.${value}-checkbox`,

  // BoundingBoxPopUp
  BOUNDING_BOX_CLOSE_BUTTON: `${DocumentTestIdsScope.BOUNDING_BOX}.close-button`,

  // DocumentsTreeHeader
  TREE_HEADER_COLLAPSE_BUTTON: `${DocumentTestIdsScope.TREE_HEADER}.collapse-button`,
  TREE_HEADER_COLLAPSE_PANEL_BUTTON: `${DocumentTestIdsScope.TREE_HEADER}.collapse-panel-button`,
  AI_BATCH_INTAKE_BUTTON: `${DocumentTestIdsScope.TREE_HEADER}.ai-batch-intake-button`,
  getTreeHeaderIconButtonId: index => `${DocumentTestIdsScope.TREE_HEADER}.icon-button-${index}`,

  // ExtractionField (Edit / View)
  getExtractionFieldSelectId: fieldId =>
    `${DocumentTestIdsScope.EXTRACTION_FIELD}.${fieldId}-select`,
  getExtractionFieldCheckboxId: fieldId =>
    `${DocumentTestIdsScope.EXTRACTION_FIELD}.${fieldId}-checkbox`,
  getExtractionFieldInputId: fieldId => `${DocumentTestIdsScope.EXTRACTION_FIELD}.${fieldId}-input`,

  // DocumentView
  DOCUMENT_PREVIEW_OVERLAY_DELETE_PAGE_BUTTON: `${DocumentTestIdsScope.DOCUMENT_PREVIEW}.overlay-delete-page-button`,
  DOCUMENT_PREVIEW_PAGE_CANVAS: `${DocumentTestIdsScope.DOCUMENT_PREVIEW}.page-canvas`,
  THUMBNAIL: `${TestIdDomain.DOCUMENT}.${DocumentTestIdsScope.THUMBNAIL}`,
  THUMBNAIL_OVERLAY: `${DocumentTestIdsScope.THUMBNAIL}.overlay`,

  // DocumentsTreeView
  TREE: `${TestIdDomain.DOCUMENT}.tree`,

  // EditExtractionFieldsForm
  FIELDS: `${TestIdDomain.DOCUMENTS}.fields`,
  EXTRACTION_FIELDS_SAVE_BUTTON: 'extraction-fields-save.button',
  REJECT_DOCUMENT_BUTTON: `${DocumentTestIdsScope.REJECT_DOCUMENT}.button`,
  SKIP_DOCUMENT_BUTTON: 'skip-document.button',

  // HistoryTable
  ACTIONS_TABLE: 'actions-table.table',
  HISTORY_TABLE_ROW_REJECT_REASON_BUTTON: `${DocumentTestIdsScope.HISTORY_TABLE_ROW}.reject-reason-button`,

  // RejectDocumentForm
  REJECT_REASON_INPUT: `${TestIdDomain.DOCUMENT}.reject-reason-input`,
  REJECT_DOCUMENT_FORM: `${DocumentTestIdsScope.REJECT_DOCUMENT}.form`,
  REJECT_DOCUMENT_SUBMIT_BUTTON: `${DocumentTestIdsScope.REJECT_DOCUMENT}.submit-button`,

  // ThumbnailControlPanel
  DOCUMENT_PREVIEW_SPLIT_DOCUMENT_BUTTON: `${DocumentTestIdsScope.DOCUMENT_PREVIEW}.split-document-button`,
  DOCUMENT_PREVIEW_THUMBNAIL_CONTROL_PANEL: `${DocumentTestIdsScope.DOCUMENT_PREVIEW}.thumbnail-control-panel`,
  DOCUMENT_PREVIEW_TOGGLE_PAGES_BUTTON: `${DocumentTestIdsScope.DOCUMENT_PREVIEW}.toggle-pages-button`,

  // UploadDocumentsModal
  DOCUMENTS_UPLOAD_BROWSE_BUTTON: `${DocumentTestIdsScope.DOCUMENTS_UPLOAD}.browse-button`,
  DOCUMENTS_UPLOAD_CLEAR_BUTTON: `${DocumentTestIdsScope.DOCUMENTS_UPLOAD}.clear-button`,
  DOCUMENTS_UPLOAD_DELETE_BUTTON: `${DocumentTestIdsScope.DOCUMENTS_UPLOAD}.delete-button`,
  DOCUMENTS_UPLOAD_DROPZONE: `${DocumentTestIdsScope.DOCUMENTS_UPLOAD}.dropzone`,
  DOCUMENTS_UPLOAD_ERROR_ICON: `${DocumentTestIdsScope.DOCUMENTS_UPLOAD}.error-icon`,
  DOCUMENTS_UPLOAD_ERROR_TEXT_LABEL: `${DocumentTestIdsScope.DOCUMENTS_UPLOAD}.error-text-label`,
  DOCUMENTS_UPLOAD_FILE_INPUT: `${DocumentTestIdsScope.DOCUMENTS_UPLOAD}.file-input`,
  DOCUMENTS_UPLOAD_SELECTED_FILE_CARD: `${DocumentTestIdsScope.DOCUMENTS_UPLOAD}.selected-file-card`,
  DOCUMENTS_UPLOAD_SPINNER: `${DocumentTestIdsScope.DOCUMENTS_UPLOAD}.spinner`,
  DOCUMENTS_UPLOAD_SUCCESS_ICON: `${DocumentTestIdsScope.DOCUMENTS_UPLOAD}.success-icon`,
  DOCUMENTS_UPLOAD_UPLOAD_BUTTON: `${DocumentTestIdsScope.DOCUMENTS_UPLOAD}.upload-button`,
  DOCUMENTS_UPLOAD_UPLOADED_FILE_CARD: `${DocumentTestIdsScope.DOCUMENTS_UPLOAD}.uploaded-file-card`,

  // Dynamic
  getAddNewDynamicContainerButtonId: name => `dynamic-container.add-new-${name}-button`,
  getRemoveDynamicContainerButtonId: name => `dynamic-container.remove-${name}-button`,
  getCategoryId: id => `category.${id}`,
  getTableHeadLabelId: id => `table-head.label-${id}`,
  getTypesContainerId: id => `types-container.${id}`,
};
